import { all } from "redux-saga/effects";

import geoLocationWatcher from "./geoLocationSaga";
import authFirebaseSaga from "./authFirebaseSaga";
import uploadFirestoreSaga from "./uploadFirestoreSaga";
import getSonviListSaga from "./getSonviListSaga";

export default function* rootSaga() {
  yield all([
    geoLocationWatcher(),
    authFirebaseSaga(),
    uploadFirestoreSaga(),
    getSonviListSaga(),
  ]);
}
